import { render, staticRenderFns } from "./VrstaTeme2Details.vue?vue&type=template&id=38f91da1&scoped=true&"
import script from "./VrstaTeme2Details.vue?vue&type=script&lang=js&"
export * from "./VrstaTeme2Details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f91da1",
  null
  
)

export default component.exports